<template>
  <el-form ref="baseForm" label-width="120px" :rules="baseRules" :model="baseForm">
    <h2>基本信息</h2>
    <el-divider></el-divider>
    <el-row>
      <el-form-item label="标题" prop="title">
        <el-col :span="16">
          <el-input placeholder="组合标题" v-model.trim="baseForm.title"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="组合简介" prop="about">
        <el-col :span="16">
          <el-input placeholder="请填写简介" v-model.trim="baseForm.about" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="分类" prop="category_id">
        <el-col :span="16">
          <SelectTree :props="props" :options="category" :value="parseInt(baseForm.category_id)" @getValue="getValue($event)"></SelectTree>
        </el-col>
      </el-form-item>
      <!-- <el-tree :data="options" node-key="100" ref="etree"></el-tree> -->
    </el-row>
    <el-row>
      <el-form-item label="标签">
        <el-col :span="16">
          <!-- <el-input placeholder="请输入标签"></el-input> -->
          <el-select v-model="baseForm.tags" multiple filterable default-first-option reserve-keyword ref="tags" placeholder="请选择应用标签">
            <el-option v-for="item in tags" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="封面图片" prop="cover" class="red_dot">
        <el-upload class="upload-cover" drag action="/api/file/upload" accept=".jpg, .png, .gif, .JPG, .PNG, .GIF" :headers="headers()" :data="token"
          :on-success="handleCoverSuccess" :before-upload="beforeCoverUpload" :show-file-list="false">
          <i class="el-icon-upload" v-if="!cover"></i>
          <div class="el-upload__text" v-if="!cover">
            <em>点击上传</em>
          </div>
          <img v-if="cover" :src="common.filepath(cover)" class="cover" />
          <div class="el-upload__tip" slot="tip">
            建议上传200px*200px，只能上传jpg/png/gif文件，且不超过2M
          </div>
        </el-upload>
      </el-form-item>
    </el-row>
    <el-divider></el-divider>
    <el-form-item>
      <el-button type="primary" @click="submitForm('baseForm', handleUpdate)" :plain="true">保存设置</el-button>
      <el-button @click="next()">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getCategory } from "@/api/apps";
import {
  uploadFileToken,
  uploadFile,
  saveFile,
  deleteFile
} from "@/api/file";
import SelectTree from "@/components/TreeSelect.vue";
import TinymceEditor from "@/components/TinymceEditor";
import { searchTag } from "@/api/course";
import { updateClassroom } from "@/api/classroom";
import { getToken } from "@/utils/auth";
import qs from "qs";
export default {
  components: {
    SelectTree,
    TinymceEditor
  },
  methods: {
    next() {
      this.$router.push({
        name: "classroom-contest"
      });
    },

    handleCoverSuccess(res, file) {
      this.cover = URL.createObjectURL(file.raw);
      this.baseForm.cover = res.uri;
    },
    beforeCoverUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传封面图片只能是 jpg、png、gif 格式!");
      }
      // if (isPNG) {
      //     this.$message.error('上传封面图片只能是 PNG 格式!');
      //   }
      // if (isJPG) {
      //     this.$message.error('上传封面图片只能是 JPG 格式!');
      //   }
      if (!isLt2M) {
        this.$message.error("上传封面图片大小不能超过 2M");
      }
      return isLt2M && (isJPG || isPNG || isGIF);
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          return false;
        }
      });
    },
    //附件上传限制提示
    handleExceed() {
      this.$message.warning("最多上传5个附件");
    },

    //附件上传移除确定
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
    },
    handleRemove(file, fileList) {
      var data = {
        ids: [file.id],
        isDeleteFile: 1
      };

      deleteFile(this.$route.params.classroomId, qs.stringify(data)).then(
        response => {
          if (response.code === 200) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
          this.handleList();
        }
      );
    },
    //实时搜索标签
    searchTag(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          // var params = {
          //   q: query,
          //   page_limit: 10,
          // }
          // searchTag(params).then(response => {
          //   this.loading = false;
          //   this.tagsOption = response.data;
          // });
          // this.loading = false;
          //   this.tagsOption = this.tags.filter(item => {
          //     return item.name.toLowerCase()
          //       .indexOf(query.toLowerCase()) > -1;
          //   });
        }, 200);
      } else {
        this.tagsOption = [];
      }
    },
    handleUpdate() {
      var params = [];
      params.title = this.baseForm.title;
      params.about = this.baseForm.about;
      params.categoryId = this.baseForm.category_id;
      params.tags = this.baseForm.tags.join(",");
      // params.cover = {
      //   large: this.baseForm.cover,
      //   middle: this.baseForm.cover,
      //   small: this.baseForm.cover
      // };
      params.smallPicture = this.baseForm.cover
      params.middlePicture = this.baseForm.cover
      params.largePicture = this.baseForm.cover
      let that = this;
      updateClassroom(this.$route.params.classroomId, qs.stringify(params)).then(
        response => {
          this.$message.success({
            message: "保存成功"
          });
          this.$emit("refresh");
          // this.$message({
          //   message: response.message,
          //   type: 'success'
          // });
        }
      );
    },
    handleTags() {
      var params = {
        q: "",
        page_limit: 10
      };
      searchTag(params).then(response => {
        this.tags = response.data.data;
      });
    },
    limitInput() {
      var input = document.getElementsByClassName("el-select__input").item(0);
      input.setAttribute("maxlength", "10");
    },

    getValue(value) {
      this.baseForm.category_id = value;
    },

    headers() {
      var token = getToken();
      return { "XX-Token": token, "XX-Device-Type": "web" };
    },
    maxLength() {
    }
  },
  data() {

    const validateCover = (rule, value, callback) => {
      if (this.cover == 0) {
        callback(new Error("请上传封面"));
      } else {
        callback();
      }
    };
    const validateCategory = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error("请选择分类"));
      } else {
        callback();
      }
    };
    const validateSummary = (rule, value, callback) => {
      if (value == null || value == "") {
        callback(new Error("请输入组合详情"));
      } else {
        callback();
      }
    };
    return {
      baseForm: {
        title: "",
        about: "",
        tags: "",
        category_id: 0,
        cover: ""
      },
      baseRules: {
        title: [
          { required: true, trigger: "change", message: "请输入标题" },
          {
            min: 1,
            max: 30,
            message: "请输入1-30 个字符",
            trigger: "change"
          }
        ],
        about: [
          { max: 200, message: "长度请在 200 个字符内", trigger: "change" }
        ],
        // tags: [
        //   {required: true, trigger: "blur", validator: validateUsername}
        // ],
        category_id: [
          { required: true, trigger: "change", validator: validateCategory }
        ],
        cover: [{ required: false, trigger: "blur", validator: validateCover }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      tagsOption: [],
      props: {
        // 配置项（必选）
        value: "id",
        label: "name",
        children: "children"
        // disabled:true
      },
      tags: [],
      classroom: null,
      categorys: [],
      category: null,
      loading: false,
      value: "",
      icon: "",
      cover: "",
      coverArr: null,
      imageUrl: "",
      course: "",
      token: null,
      uploadToken: "",
      fileList: []
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   getCourse(to.params.classroomId).then(response => {
  //     // 
  //     next(vm => {
  //       vm.categorys = response.data.category;
  //       vm.course = response.data.course;
  //       vm.baseForm.title = vm.course.title;
  //       vm.baseForm.subtitle = vm.course.subtitle;
  //       vm.baseForm.category_id = vm.course.category_id;
  //       vm.baseForm.tags = vm.course.tags ? vm.course.tags.split(",") : "";
  //       vm.baseForm.serialize_mode = vm.course.serialize_mode;

  //       vm.icon = vm.course.icon;
  //       vm.cover = vm.course.cover;
  //       vm.baseForm.summary = vm.course.summary;
  //     });
  //   });
  // },
  // computed:{
  //   /* 转树形数据 */
  //   optionData(){
  //     let cloneData = JSON.parse(JSON.stringify(this.list))      // 对源数据深度克隆
  //     return  cloneData.filter(father=>{                      // 循环所有项，并添加children属性
  //         let branchArr = cloneData.filter(child=>father.id == child.parentId);       // 返回每一项的子级数组
  //         branchArr.length>0 ? father.children=branchArr : ''   //给父级添加一个children属性，并赋值
  //         return father.parentId==0;      //返回第一层
  //     });
  //   }
  // },

  created() {
    this.handleTags();
    this.classroom = { ...this.$attrs.classroom };
    this.category = this.$attrs.category;
    this.baseForm.title = this.classroom.title;
    this.baseForm.about = this.classroom.about;
    this.baseForm.tags = this.$attrs.tags;
    this.baseForm.category_id = this.classroom.categoryId;
    this.baseForm.cover = this.classroom.middlePicture;
    this.cover = this.classroom.middlePicture;


    this.token = this.$attrs.token;
    this.uploadToken = this.$attrs.uploadToken;

    // getCourse(this.$route.params.classroomId).then(response => {
    //   
    // });
  },

  mounted() { }
};
</script>

<style scoped>
/* .el-form {
    padding: 10px;
} */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.upload-cover >>> .el-upload-dragger {
  width: 150px;
  height: 150px;
}
.cover {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
}
.red_dot >>> .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.avatar-uploader >>> .el-upload--picture-card {
  width: 102px;
  height: 102px;
  line-height: 100px;
  overflow: hidden;
}
</style>
